import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import night_mode_gen_2 from '@devices/settings/device_settings/night_mode_gen_2.js';
import addon_sensors, {
	addon_plus_devices_g3,
} from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import app_setting_plus_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_plus_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import dimmer_0110_settings from '@devices/settings/device_settings/dimmer_0110_settings.js';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';
import { createSceneCapabilities } from '@components/Flows/sceneCapabilities/index.js';

export default {
	name: 'Shelly0110DimG3',
	friendly_name: 'Dimmer 0/1-10V PM Gen3',
	reset_from_input: true,
	family: 'light',
	isPM: true,
	addons: addon_plus_devices_g3,
	modes: {
		light: {
			sceneCapabilities: createSceneCapabilities({
				template: 'single_dimmer',
			}),
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'forgotten_lights',
				'overvoltage',
				'overtemperature',
			],
			color_temp: false,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				night_mode_gen_2,
				addon_sensors,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				app_setting_plus_rgbw_gen_2,
				share,
				dimmer_0110_settings,
			],
		},
	},
};
